// extracted by mini-css-extract-plugin
export default {"selectInput":"select_selectInput__oIHd6","minimal":"select_minimal__IbnQY"};